import { PropGetter } from '@chakra-ui/react-utils';
import { useCallback, useMemo } from 'react';
import { useRangeSliderContext } from './range-slider-context';
import { getTrackPercent, orient } from './range-slider-utils';

export type UseRangeSliderInnerTrackProps = {
  startThumbKey?: number;
  endThumbKey?: number;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useRangeSliderInnerTrack = (props: UseRangeSliderInnerTrackProps) => {
  const { startThumbKey, endThumbKey } = props;
  const { values, min, max, orientation, isReversed } = useRangeSliderContext();
  const startValueContext = isReversed ? max : min;
  const endValueContext = isReversed ? min : max;

  const startValue =
    (startThumbKey !== undefined ? values[startThumbKey] : startValueContext) ?? startValueContext;

  const endValue =
    (endThumbKey !== undefined ? values[endThumbKey] : endValueContext) ?? endValueContext;

  const startTrackPercent = getTrackPercent(startValue, min, max, isReversed);
  const endTrackPercent = getTrackPercent(endValue, min, max, isReversed);

  const innerTrackStyle: React.CSSProperties = useMemo(
    () => ({
      position: 'absolute',
      ...orient({
        orientation,
        vertical: {
          top: `${startTrackPercent}%`,
          height: `${endTrackPercent - startTrackPercent}%`,
          left: '50%',
          transform: 'translateX(-50%)',
        },
        horizontal: {
          left: `${startTrackPercent}%`,
          width: `${endTrackPercent - startTrackPercent}%`,
        },
      }),
    }),
    [endTrackPercent, orientation, startTrackPercent]
  );

  const getInnerTrackProps: PropGetter = useCallback(
    // eslint-disable-next-line no-null/no-null
    (propss = {}, ref = null) => ({
      ...propss,
      ref,
      style: {
        ...propss.style,
        ...innerTrackStyle,
      },
    }),
    [innerTrackStyle]
  );

  return {
    getInnerTrackProps,
  };
};
